import React from 'react';

import { ISanitizer, sanitize } from '~commonInfra/utils/Sanitize';

import { TextileHelper } from '../../../utils/TextileHelper';
import { DetailsTooltipStyles } from '../../card/DetailsTooltipStyles';
import { ContentDescriptionClassNames } from '../../tooltip/TooltipHelper';

export interface MarkupFieldProps {
  label?: string;
  markup: string;
  testId?: string;
  extraClasses?: string[];
  excludeImages?: boolean;
  disableMaxHeight?: boolean;
}

export function MarkupField(props: MarkupFieldProps) {
  const sanitizeFn = sanitize;
  const htmlContent = getSanitizedHtmlFromMarkup(props.markup, sanitizeFn);

  if (!props.markup || !htmlContent) {
    return null;
  }

  // Open anchor tag links in a new tab by default
  const $tempElement = $('<div></div>').html(htmlContent.__html);
  $tempElement.find('a').not('[target]').attr('target', '_blank');
  if (props.excludeImages) {
    $tempElement.find('img').remove();
  }
  htmlContent.__html = $tempElement.html();

  const classes = [DetailsTooltipStyles.MetadataSection].concat(props.extraClasses).join(' ');

  return (
    <div className={classes}
      data-tb-test-id={props.testId}>

      {props.label && <div className={DetailsTooltipStyles.MultiLineTitle}>{props.label}</div>}

      <div className={ContentDescriptionClassNames} style={{ maxHeight: props.disableMaxHeight ? 'none' : 'inherit' }}
        dangerouslySetInnerHTML={htmlContent} />

    </div>
  );
}

function getSanitizedHtmlFromMarkup(
  markup: string,
  sanitizeFn: ISanitizer
): { __html: string } {
  return { __html: TextileHelper.getSanitizedHtmlFromTextile(markup, sanitizeFn) };
}
